var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.cards),function(c,index){return _c('WordCard',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],key:index,attrs:{"jWord":c.jWord,"eWord":c.eWord,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }